// RadioField.tsx
"use client";

import * as React from "react";
import { Field, HStack, Text } from "@chakra-ui/react";
import { RadioGroup } from "@chakra-ui/react";
import useControllable from "hooks/useControllable/useControllable";

export interface RadioOption {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface RadioFieldProps {
  id: string;
  label?: string;
  value?: string;
  defaultValue?: string;
  required?: boolean;
  helperText?: string;
  error?: string;
  options: RadioOption[];
  onChange?: (value: string) => void;
}

const RadioField: React.FC<RadioFieldProps> = (props) => {
  const { label, required, helperText, error, options } = props;

  const [value, setValue] = useControllable<string>({
    value: props.value,
    defaultValue:
      props.defaultValue ??
      options.find((o) => (o as any).default)?.value ??
      "",
    onChange: props.onChange,
  });

  return (
    <Field.Root invalid={!!error} required={!!required}>
      {label && (
        <Field.Label>
          {label}
          {required && <Field.RequiredIndicator />}
        </Field.Label>
      )}

      <RadioGroup.Root
        value={value}
        onValueChange={(details: any) => {
          const v = details?.value ?? details ?? "";
          setValue(v);
        }}
      >
        <HStack gap={4}>
          {options.map((o) => (
            <RadioGroup.Item
              key={o.value}
              value={o.value}
              disabled={o.disabled}
              style={{ cursor: "pointer" }}
            >
              <RadioGroup.ItemHiddenInput name={props.id} />
              <RadioGroup.ItemIndicator />
              <RadioGroup.ItemText>
                <Text fontSize="sm">{o.label}</Text>
              </RadioGroup.ItemText>
            </RadioGroup.Item>
          ))}
        </HStack>
      </RadioGroup.Root>

      {error ? (
        <Field.ErrorText>{error}</Field.ErrorText>
      ) : helperText ? (
        <Field.HelperText>{helperText}</Field.HelperText>
      ) : null}
    </Field.Root>
  );
};

export default RadioField;
